export default "__VITE_ASSET__b84640fa__"